/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown>, value: NonNullable<unknown> }} Voucher_ResultInputs */

const en_voucher_result = /** @type {(inputs: Voucher_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.code}: ${i?.value} off`)
};

const id_voucher_result = /** @type {(inputs: Voucher_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.code}: potongan ${i?.value}`)
};

/**
* | output |
* | --- |
* | "{code}: {value} off" |
*
* @param {Voucher_ResultInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const voucher_result = /** @type {((inputs: Voucher_ResultInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voucher_ResultInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_voucher_result(inputs)
	return en_voucher_result(inputs)
});